// extracted by mini-css-extract-plugin
export var circle = "card-module--circle--46958";
export var circleImage = "card-module--circleImage--28b09";
export var customFont = "card-module--customFont--35468";
export var pill = "card-module--pill--b508e";